module.exports = __webpack_public_path__ + "fonts/trust_sans_medium-webfont.e7548643.woff2";